module.exports = __webpack_public_path__ + "fonts/fa-brands-400.98b6db5.ttf";